import { render, staticRenderFns } from "./RideTypeForm.vue?vue&type=template&id=72503716&"
import script from "./RideTypeForm.vue?vue&type=script&lang=js&"
export * from "./RideTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./RideTypeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports